import React from 'react';
import ErrorCS from '../../pages/Error/ErrorCS';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorCS />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
